import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { ArrowRightOutlined, PlusCircleOutlined } from '@ant-design/icons';

import { Button, Flex, Modal, ModalProps, Typography } from 'antd';

import affileadLogo from 'assets/images/connectSource/affilead-logo.svg';
import mitgoIdLogo from 'assets/images/connectSource/mitgo-logo.svg';
import { useRedirectToCreateAdspace } from 'entities/Adspace';
import { useConnectSourceSlice } from 'features/ConnectSource';
import { AdspaceList } from 'widgets/AdspaceList';

import styles from './ConnectSource.module.scss';

interface IConnectSourceProps extends ModalProps {}

export const ConnectSource: FC<IConnectSourceProps> = ({ ...props }) => {
	const { t } = useTranslation();
	const [searchParams, setSearchParams] = useSearchParams();
	const { modalIsOpened, setModalIsOpened } = useConnectSourceSlice();
	const { createAdspaceFullUrl } = useRedirectToCreateAdspace();

	useEffect(() => {
		if (modalIsOpened) {
			searchParams.set('connectSourceModal', 'true');
		} else {
			searchParams.delete('connectSourceModal');
		}
		setSearchParams(searchParams);
	}, [modalIsOpened]); // eslint-disable-line react-hooks/exhaustive-deps

	if (!modalIsOpened) return null;

	return (
		<Modal
			{...props}
			width={900}
			centered
			footer={null}
			open={modalIsOpened}
			onCancel={() => setModalIsOpened(false)}
			closeIcon={false}>
			<Flex vertical gap={24}>
				<Flex gap={10} align="center" justify="space-between">
					<Flex vertical gap={4}>
						<Typography.Title level={4} style={{ margin: 0 }}>
							{t('Подключить площадку из Mitgo ID')}
						</Typography.Title>
						<Typography.Text type="secondary">
							{t('Выберите верифицированную площадку  или создайте новую для подключения.')}
						</Typography.Text>
					</Flex>
					<Flex gap={12} align="center">
						<img src={mitgoIdLogo} alt="Mitgo ID" width={52} height={52} />
						<ArrowRightOutlined className={styles.arrow} />
						<img src={affileadLogo} alt="Mitgo ID" width={52} height={52} />
					</Flex>
				</Flex>

				<AdspaceList />

				<Flex gap={16} justify="space-between">
					<Button type="link" onClick={() => setModalIsOpened(false)}>
						{t('Закрыть')}
					</Button>
					<Button icon={<PlusCircleOutlined />} href={createAdspaceFullUrl}>
						{t('Создать новую площадку')}
					</Button>
				</Flex>
			</Flex>
		</Modal>
	);
};
